import $ from 'jquery';
import { has } from 'lodash';

const $window = $(window);
const form = $('#frm-contact-form');
const messenger = form.find('.contact-form-msg');

form.on('submit', async function (e) {
    
    e.preventDefault();

    const form = $(this)[0];

    const formData = new FormData(form);
    let hasError = false;

    if (formData.get('email') === '') {
        if (getLang() === 'sk') {
            addInputError(form.querySelector('#frm-contact-form-email'), 'Vyplňte prosím e-mailovú adresu');
        } else {
            addInputError(form.querySelector('#frm-contact-form-email'), 'Fill email address please');
        }
        hasError = true;
    } else {
        if (!validovatEmail(formData.get('email'))) {
            if (getLang() === 'sk') {
                addInputError(form.querySelector('#frm-contact-form-email'), 'E-mailová adresa nie je platná');
            } else {
                addInputError(form.querySelector('#frm-contact-form-email'), 'Email address is not valid');
            }
        }
        hasError = true;
    }

    if (formData.get('message') === '') {
        if (getLang() === 'sk') {
            addInputError(form.querySelector('#frm-contact-form-message'), 'Vyplňte prosím správu');
        } else {
            addInputError(form.querySelector('#frm-contact-form-message'), 'Fill message please');
        }
        hasError = true;
    }

    console.log(formData.get('chckbx_confirm_data'));
    if (formData.get('chckbx_confirm_data') === null){
        if (getLang() === 'sk') {
            addInputError(form.querySelector('#frm-contact-form-chckbx_confirm_data'), 'Potvrďte spracovanie osobných údajov');
        } else {
            addInputError(form.querySelector('#frm-contact-form-chckbx_confirm_data'), 'Confirm processing of personal data');
        }
        hasError = true;
    }

    if (hasError) {
        return;
    }
    $window.trigger('loader:show');
    const data = await send(formData);

    validData(data);
    $window.trigger('loader:hide');
});

const send = async filter => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/kvop/v1/contact-send', {
            method: 'POST',
            body: filter,
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};

const validData = data => {
    messenger.removeClass('form-msg__success, form-msg__err');
    form.find('#frm-contact-form-email, #frm-contact-form-message').val('');

    'status' in data && data.status
        ? messenger.addClass('form-msg__success')
        : messenger.addClass('form-msg__err');

    messenger.html(data.message).show(300);
};

const addInputError = (elem, msg = "") => {
    let parent = $(elem).parent();
    if ($(elem).hasClass("select__control") || $(elem).attr("type") == "checkbox") {
        parent = parent.parent();
    }
    parent.addClass("has-error");

    let error = parent.find(".error");
    if (error.length === 0) {
        parent.append(`<div class="error">${msg}</div>`);
    } else {
        error.html(msg);
    }
}

function validovatEmail(email) {
    // Definícia regulárneho výrazu pre e-mailovú adresu
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Testovanie e-mailovej adresy pomocou regulárneho výrazu
    return regex.test(email);
}

const getLang = () => {
    return $("html").attr("lang");
}